import { useEffect, useRef } from 'react';
import { canUseDom } from '../dom-utils';
/**
 * Restores focus in last focused element.
 *
 * @example
 * const Modal = (props) => {
 *   const { isVisible } = props
 *
 *   useRestoreFocus({ enabled: isVisible })
 *   ...
 * }
 */
export function useRestoreFocus(props) {
    var enabled = props.enabled, restoreFocusRef = props.restoreFocusRef;
    var initialActiveElement = useRef(null);
    var ref = useRef(null);
    if (enabled && !initialActiveElement.current) {
        // For elements with autoFocus React sets focus programmatically,
        // because important catch active element at render phase.
        initialActiveElement.current = canUseDom ? document.activeElement : null;
    }
    useEffect(function () {
        ref.current = restoreFocusRef ? restoreFocusRef.current : null;
    });
    useEffect(function () {
        if (!enabled) {
            return;
        }
        return function () {
            var element = ref.current || initialActiveElement.current;
            initialActiveElement.current = null;
            ref.current = null;
            if (element &&
                element.focus &&
                document.body.contains(element) &&
                element !== document.activeElement) {
                element.focus();
            }
        };
    }, [enabled]);
}
